module.exports = __webpack_public_path__ + "img/dzw.72e63302.jpg";